var map = {
	"./editorBaseApi": [
		65454
	],
	"./editorBaseApi.js": [
		65454
	],
	"./editorSimpleWorker": [
		84919
	],
	"./editorSimpleWorker.js": [
		84919
	],
	"./editorWorker": [
		22227
	],
	"./editorWorker.js": [
		22227
	],
	"./editorWorkerHost": [
		28825
	],
	"./editorWorkerHost.js": [
		28825
	],
	"./findSectionHeaders": [
		49296
	],
	"./findSectionHeaders.js": [
		49296
	],
	"./getIconClasses": [
		91655
	],
	"./getIconClasses.js": [
		91655
	],
	"./languageFeatureDebounce": [
		99561
	],
	"./languageFeatureDebounce.js": [
		99561
	],
	"./languageFeatures": [
		79929
	],
	"./languageFeatures.js": [
		79929
	],
	"./languageFeaturesService": [
		55069
	],
	"./languageFeaturesService.js": [
		55069
	],
	"./languageService": [
		65207
	],
	"./languageService.js": [
		65207
	],
	"./languagesAssociations": [
		46977
	],
	"./languagesAssociations.js": [
		46977
	],
	"./languagesRegistry": [
		76670
	],
	"./languagesRegistry.js": [
		76670
	],
	"./markerDecorations": [
		5543
	],
	"./markerDecorations.js": [
		5543
	],
	"./markerDecorationsService": [
		66768
	],
	"./markerDecorationsService.js": [
		66768
	],
	"./model": [
		64043
	],
	"./model.js": [
		64043
	],
	"./modelService": [
		63780
	],
	"./modelService.js": [
		63780
	],
	"./resolverService": [
		66799
	],
	"./resolverService.js": [
		66799
	],
	"./semanticTokensDto": [
		10257
	],
	"./semanticTokensDto.js": [
		10257
	],
	"./semanticTokensProviderStyling": [
		88970
	],
	"./semanticTokensProviderStyling.js": [
		88970
	],
	"./semanticTokensStyling": [
		36522
	],
	"./semanticTokensStyling.js": [
		36522
	],
	"./semanticTokensStylingService": [
		3375
	],
	"./semanticTokensStylingService.js": [
		3375
	],
	"./textModelSync/textModelSync.impl": [
		38551
	],
	"./textModelSync/textModelSync.impl.js": [
		38551
	],
	"./textModelSync/textModelSync.protocol": [
		93607,
		3607
	],
	"./textModelSync/textModelSync.protocol.js": [
		93607,
		3607
	],
	"./textResourceConfiguration": [
		50233
	],
	"./textResourceConfiguration.js": [
		50233
	],
	"./treeSitterParserService": [
		28821
	],
	"./treeSitterParserService.js": [
		28821
	],
	"./treeViewsDnd": [
		61632
	],
	"./treeViewsDnd.js": [
		61632
	],
	"./treeViewsDndService": [
		58793
	],
	"./treeViewsDndService.js": [
		58793
	],
	"./unicodeTextModelHighlighter": [
		51750
	],
	"./unicodeTextModelHighlighter.js": [
		51750
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": [
		65454
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": [
		65454
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": [
		84919
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": [
		84919
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker": [
		22227
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": [
		22227
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": [
		28825
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": [
		28825
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": [
		49296
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": [
		49296
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": [
		91655
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": [
		91655
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": [
		99561
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": [
		99561
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": [
		79929
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": [
		79929
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": [
		55069
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": [
		55069
	],
	"monaco-editor/esm/vs/editor/common/services/languageService": [
		65207
	],
	"monaco-editor/esm/vs/editor/common/services/languageService.js": [
		65207
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": [
		46977
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": [
		46977
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": [
		76670
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": [
		76670
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": [
		5543
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": [
		5543
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": [
		66768
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": [
		66768
	],
	"monaco-editor/esm/vs/editor/common/services/model": [
		64043
	],
	"monaco-editor/esm/vs/editor/common/services/model.js": [
		64043
	],
	"monaco-editor/esm/vs/editor/common/services/modelService": [
		63780
	],
	"monaco-editor/esm/vs/editor/common/services/modelService.js": [
		63780
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService": [
		66799
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": [
		66799
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": [
		10257
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": [
		10257
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": [
		88970
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": [
		88970
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": [
		36522
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": [
		36522
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": [
		3375
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": [
		3375
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": [
		38551
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": [
		38551
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": [
		93607,
		3607
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": [
		93607,
		3607
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": [
		50233
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": [
		50233
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": [
		28821
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": [
		28821
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": [
		61632
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": [
		61632
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": [
		58793
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": [
		58793
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": [
		51750
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": [
		51750
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;